const endpoints = {
  getBlogFormOptions: `/api/v1/blogs/meta/`,
  GenerateBlog: `/api/v1/blogs/generate`,
};
export default endpoints;
